// Vue
import { createApp } from "vue";
import Widget from "./Widget.vue";

// L
import "./../node_modules/leaflet/dist/leaflet.js";
import "./../node_modules/leaflet/dist/leaflet.css";

import "./leaflet.css"; // overrides

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("./../node_modules/leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("./../node_modules/leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("./../node_modules/leaflet/dist/images/marker-shadow.png"),
  /*iconSize: [24, 36],
  iconAnchor: [12, 36],*/
});

// create vue app
const app = createApp(Widget);
app.mount("#kaart");
